import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next'


export default function ButtonSSO({ tooltip, name, icon, href }) {

    const { t } = useTranslation(['login'])

    function onClick() {
        localStorage.setItem("SSO.Autoselect", name)
    }

    return (
        <Button 
            href={href} 
            block icon={icon}
            onClick={onClick}
            >
            {`${t("login.sso")} ${name}`}
        </Button>
    )
}